import { render, staticRenderFns } from "./positive_review_settings.vue?vue&type=template&id=c1833918&scoped=true"
import script from "./positive_review_settings.vue?vue&type=script&lang=js"
export * from "./positive_review_settings.vue?vue&type=script&lang=js"
import style0 from "./positive_review_settings.vue?vue&type=style&index=0&id=c1833918&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1833918",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1833918')) {
      api.createRecord('c1833918', component.options)
    } else {
      api.reload('c1833918', component.options)
    }
    module.hot.accept("./positive_review_settings.vue?vue&type=template&id=c1833918&scoped=true", function () {
      api.rerender('c1833918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/positive_review_settings.vue"
export default component.exports